const mapSimpleSubcategory = ({ subcategoryTitle, link, imageUrl }) => ({
  subcategoryTitle,
  link,
  products: {
    products: [
      {
        images: [
          {
            url: imageUrl,
            __typename: 'Image',
          },
        ],
        options: [],
        slug: `${link}-modular`,
        type: {
          name: subcategoryTitle,
        },
      },
    ],
  },
});

export default mapSimpleSubcategory;
